import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

const FIFTEEN_MIN = 15 * 60_000

export function useSensors() {
  return useQuery({
    queryKey: ['sensors'],
    queryFn: () => api.listSensors().then((r) => r.sensors),
    refetchInterval: FIFTEEN_MIN,
    staleTime: FIFTEEN_MIN - 30_000,
  })
}
